<template>
    <div class="logo-box">
        <router-link class="logo-link" to="/">
            <img src="../../assets/images/png_logo.png" >
        </router-link>
    </div>
</template>

<script>
export default {
    name: 'logo'
}
</script>

<style lang="scss" scoped>
.logo-box {
    display: flex;
    height: 86px;
    align-items: center;
    padding: 0 24px;
    background: linear-gradient(180deg, #FFFFFF 0%, #F5F5F5 100%);
    .logo-link{
        img{
            display: block;
            height: 50px;
        }
    }
}
</style>
